export const getUUID = () => {
  return new Date().getMilliseconds();
};
